import { render, staticRenderFns } from "./SdsSection2LabelSignalWordsForm.vue?vue&type=template&id=4d7068b2"
import script from "./SdsSection2LabelSignalWordsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection2LabelSignalWordsForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports